// simple wrapper around browser fetch for swr
import fetch from 'cross-fetch'

const options = {
  // Fetch options (defaults)
  credentials: 'same-origin',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-Token': '',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

// add csrf header
if (typeof document !== 'undefined') {
  let token = document.getElementsByName('csrf-token')[0]
  if (token) options.headers['X-CSRF-Token'] = token.getAttribute('content')
}

const Fetcher = (url) => {
  // Add image_size parameter for event endpoints
  if (url.includes('/whatson/')) {
    const urlObj = new URL(url, window.location.origin)
    urlObj.searchParams.set('image_size', 'small')
    url = urlObj.pathname + urlObj.search
  }
  
  return fetch(url, options).then((res) => res.json())
}

export default Fetcher
